import { atom, selector } from "recoil"
import { accountSelector } from "src/recoil/selectors/account/accountSelector"

export const cityIdState = atom({
  key: "atoms/account/cityIdState",
  default: selector({
    key: "atoms/account/cityIdState_default",
    get: ({ get }) => {
      const account = get(accountSelector)
      return account?.cityId
    },
  }),
})
